let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ex1MV")).then(() => parcelRequire('6gWmN'));